import React, { useEffect, useMemo, useState } from "react";

const API_URL = "https://appcorp.parma.com.gt/apipp/ReceptorDatos";

const TOKEN =
  "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY";

async function callCrud(datosRecibidos) {
  const body = {
    Token: TOKEN,
    Ambiente: "DESA",
    Dispositivo: {
      Marca: "WEB",
      Modelo: "React",
      Version: "1.0",
      McAdress: null,
      PowerStatus: "100%",
      WifiStatus: "ONLINE",
      GPSStatus: "OFF",
      GPS: "",
    },
    User: {
      Codigo: "",
      UserNickName: "WEB",
    },
    Metodo: {
      NombreMetodo: "CRUDPesajeCajillas",
      Datos_Recibidos: JSON.stringify(datosRecibidos),
      Datos_Generados: "",
    },
    Datos: null,
  };

  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) throw new Error(`Error HTTP ${res.status}`);

  const data = await res.json();
  const raw = data.datos_Generados || data.Datos_Generados || "";

  if (!raw) return [];

  const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
  return Array.isArray(parsed.RESP) ? parsed.RESP : [];
}

function toNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function formatNumber(value) {
  const n = toNumber(value);
  return Number.isInteger(n) ? n.toString() : n.toFixed(2);
}

function formatDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("es-GT");
}

export default function ReporteDguaDetalleRecolectadoPage() {
  const [pedUniquecode, setPedUniquecode] = useState("PDGUA-20260617-001");
  const [items, setItems] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [estadoFiltro, setEstadoFiltro] = useState("todos");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function cargarReporte() {
    setLoading(true);
    setError("");

    try {
      const data = await callCrud({
        Tabla: "reporte",
        TipoOperacion: "PedidoDguaDetalleRecolectado",
        PED_UNIQUECODE: pedUniquecode,
      });

      setItems(data);
    } catch (err) {
      setError(err.message || "Error cargando reporte.");
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    cargarReporte();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtrados = useMemo(() => {
    const query = busqueda.trim().toLowerCase();

    return items.filter((item) => {
      const recolectado = toNumber(item.EstaRecolectado) === 1;
      const entarimado = toNumber(item.EstaEntarimado) === 1;

      if (estadoFiltro === "pendiente" && recolectado) return false;
      if (estadoFiltro === "recolectado" && !recolectado) return false;
      if (estadoFiltro === "entarimado" && !entarimado) return false;

      if (!query) return true;

      return [
        item.PDD_ITEMCODE,
        item.PDD_ITEMNAME,
        item.CAJ_CODIGO_UNICO,
        item.CD_LOTE,
        item.TAR_CODIGO_UNICO,
      ]
        .join(" ")
        .toLowerCase()
        .includes(query);
    });
  }, [items, busqueda, estadoFiltro]);

  const resumen = useMemo(() => {
    const productoMap = new Map();

    for (const item of items) {
      const key = item.PDD_ITEMCODE;
      if (!productoMap.has(key)) {
        productoMap.set(key, {
          confirmado: toNumber(item.PDS_CANTIDAD_CONFIRMADA),
          recolectado: 0,
          entarimado: 0,
        });
      }

      const current = productoMap.get(key);

      if (toNumber(item.EstaRecolectado) === 1) {
        current.recolectado += toNumber(
          item.CD_UNIDADES_REALES ?? item.CD_CANTIDAD
        );
      }

      if (toNumber(item.EstaEntarimado) === 1) {
        current.entarimado += toNumber(
          item.CD_UNIDADES_REALES ?? item.CD_CANTIDAD
        );
      }
    }

    let productos = productoMap.size;
    let aEnviar = 0;
    let recolectado = 0;
    let entarimado = 0;

    for (const item of productoMap.values()) {
      aEnviar += item.confirmado;
      recolectado += item.recolectado;
      entarimado += item.entarimado;
    }

    return {
      productos,
      aEnviar,
      recolectado,
      pendiente: Math.max(aEnviar - recolectado, 0),
      entarimado,
    };
  }, [items]);

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <div>
          <h1 style={styles.title}>Detalle DGUA Recolectado</h1>
          <p style={styles.subtitle}>
            Productos marcados, cajillas, lotes, pesos y tarimas
          </p>
        </div>

        <button style={styles.primaryButton} onClick={cargarReporte}>
          Actualizar
        </button>
      </header>

      <section style={styles.toolbar}>
        <input
          style={styles.input}
          value={pedUniquecode}
          onChange={(e) => setPedUniquecode(e.target.value)}
          placeholder="PDGUA-20260617-001"
        />

        <input
          style={styles.input}
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar PTPR, producto, cajilla, lote o tarima"
        />

        <select
          style={styles.input}
          value={estadoFiltro}
          onChange={(e) => setEstadoFiltro(e.target.value)}
        >
          <option value="todos">Todos</option>
          <option value="pendiente">Sin recolectar</option>
          <option value="recolectado">Recolectados</option>
          <option value="entarimado">Entarimados</option>
        </select>
      </section>

      {error && <div style={styles.error}>{error}</div>}

      <section style={styles.kpis}>
        <Kpi label="Productos" value={resumen.productos} />
        <Kpi label="A enviar" value={formatNumber(resumen.aEnviar)} />
        <Kpi label="Recolectado" value={formatNumber(resumen.recolectado)} />
        <Kpi label="Pendiente" value={formatNumber(resumen.pendiente)} />
        <Kpi label="En tarima" value={formatNumber(resumen.entarimado)} />
      </section>

      {loading ? (
        <div style={styles.empty}>Cargando reporte...</div>
      ) : filtrados.length === 0 ? (
        <div style={styles.empty}>No hay información para mostrar.</div>
      ) : (
        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Estado</th>
                <th style={styles.th}>PTPR</th>
                <th style={styles.th}>Producto</th>
                <th style={styles.th}>A enviar</th>
                <th style={styles.th}>Cajilla</th>
                <th style={styles.th}>Tipo</th>
                <th style={styles.th}>Lote</th>
                <th style={styles.th}>Vence</th>
                <th style={styles.th}>Unidades</th>
                <th style={styles.th}>Peso neto</th>
                <th style={styles.th}>Tarima</th>
              </tr>
            </thead>

            <tbody>
              {filtrados.map((item, index) => {
                const recolectado = toNumber(item.EstaRecolectado) === 1;
                const entarimado = toNumber(item.EstaEntarimado) === 1;
                const unidades = toNumber(
                  item.CD_UNIDADES_REALES ?? item.CD_CANTIDAD
                );

                return (
                  <tr key={`${item.PDD_ITEMCODE}-${item.CD_CODIGO ?? index}`}>
                    <td style={styles.td}>
                      <span
                        style={{
                          ...styles.badge,
                          background: entarimado
                            ? "#16a34a"
                            : recolectado
                            ? "#2563eb"
                            : "#ea580c",
                        }}
                      >
                        {entarimado
                          ? "Entarimado"
                          : recolectado
                          ? "Recolectado"
                          : "Pendiente"}
                      </span>
                    </td>

                    <td style={styles.tdStrong}>{item.PDD_ITEMCODE}</td>
                    <td style={styles.td}>{item.PDD_ITEMNAME}</td>
                    <td style={styles.td}>
                      {formatNumber(item.PDS_CANTIDAD_CONFIRMADA)}
                    </td>
                    <td style={styles.td}>{item.CAJ_CODIGO_UNICO || "-"}</td>
                    <td style={styles.td}>{item.CAJ_TIPO || "-"}</td>
                    <td style={styles.td}>{item.CD_LOTE || "-"}</td>
                    <td style={styles.td}>
                      {formatDate(item.CD_FECHA_VENCIMIENTO) || "-"}
                    </td>
                    <td style={styles.td}>
                      {recolectado ? formatNumber(unidades) : "-"}
                    </td>
                    <td style={styles.td}>
                      {item.PES_PESO_NETO != null
                        ? formatNumber(item.PES_PESO_NETO)
                        : "-"}
                    </td>
                    <td style={styles.td}>{item.TAR_CODIGO_UNICO || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function Kpi({ label, value }) {
  return (
    <div style={styles.kpi}>
      <div style={styles.kpiLabel}>{label}</div>
      <div style={styles.kpiValue}>{value}</div>
    </div>
  );
}

const styles = {
  page: {
    padding: 20,
    fontFamily:
      "Inter, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
    color: "#111827",
    background: "#f8fafc",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    alignItems: "center",
    marginBottom: 16,
  },
  title: {
    margin: 0,
    fontSize: 24,
  },
  subtitle: {
    margin: "4px 0 0",
    color: "#64748b",
  },
  toolbar: {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 300px) 1fr minmax(160px, 220px)",
    gap: 12,
    marginBottom: 12,
  },
  input: {
    height: 42,
    padding: "0 12px",
    border: "1px solid #cbd5e1",
    borderRadius: 6,
    fontSize: 14,
    background: "#fff",
  },
  primaryButton: {
    height: 40,
    padding: "0 16px",
    border: 0,
    borderRadius: 6,
    background: "#dc2626",
    color: "#fff",
    fontWeight: 700,
    cursor: "pointer",
  },
  error: {
    background: "#fee2e2",
    color: "#991b1b",
    border: "1px solid #fecaca",
    borderRadius: 6,
    padding: 12,
    marginBottom: 12,
  },
  kpis: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(120px, 1fr))",
    gap: 12,
    marginBottom: 16,
  },
  kpi: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 6,
    padding: 14,
  },
  kpiLabel: {
    fontSize: 12,
    color: "#64748b",
    marginBottom: 6,
  },
  kpiValue: {
    fontSize: 22,
    fontWeight: 800,
  },
  tableWrap: {
    overflow: "auto",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 6,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 1180,
  },
  th: {
    textAlign: "left",
    padding: "10px 12px",
    fontSize: 12,
    color: "#475569",
    background: "#f1f5f9",
    borderBottom: "1px solid #e2e8f0",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #e2e8f0",
    fontSize: 13,
    verticalAlign: "top",
  },
  tdStrong: {
    padding: "10px 12px",
    borderBottom: "1px solid #e2e8f0",
    fontSize: 13,
    fontWeight: 800,
    whiteSpace: "nowrap",
  },
  badge: {
    display: "inline-block",
    color: "#fff",
    borderRadius: 999,
    padding: "3px 8px",
    fontSize: 12,
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  empty: {
    padding: 32,
    textAlign: "center",
    color: "#64748b",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 6,
  },
};